export default {
    config: {
        defaultWidth: 100
    },
    default: {
        label: 'Wishlist Priority'
    },
    unique: [],
    sort: 'wishlist.priority',
    lang: {
        name: 'Wishlist Priority',
        category: ['User', 'Collection'],
        description: 'Priority set on a wishlist item.',
        views: ['list', 'sheet'],
    },
    filters: ['wishlist.priority']
}
